<template>
  <BaseModal
    small
    useForm
    :heading="$t('register.salonized_pay.dashboard.terminal.rename_heading')"
    @submit="submit"
    @close="$emit('close')"
  >
    <BaseInput
      v-model="name"
      :label="$t('register.salonized_pay.dashboard.terminal.name_label')"
      required
      v-test="'sp-terminal-rename-input'"
    />
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('close')"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="loading"
        submitForm
        v-test="'sp-terminal-rename-save'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { flash } from '@/helpers/ui';
import type { PosTerminal } from '@/types';
import { UPDATE_POS_TERMINAL } from '../../graphql';

const props = defineProps<{
  terminal: PosTerminal;
}>();

const emit = defineEmits<{
  close: [];
  renamed: [name: string];
}>();

const { t } = useI18n();

const name = ref(props.terminal.name || '');
const loading = ref(false);

const { mutate: updatePosTerminal } = useMutation(UPDATE_POS_TERMINAL);

const submit = async () => {
  loading.value = true;

  try {
    const response = await updatePosTerminal({
      input: {
        id: props.terminal.id,
        name: name.value,
      },
    });

    const newName = response?.data?.updatePosTerminal?.posTerminal?.name;
    if (newName) {
      emit('renamed', newName);
    }

    flash(t('register.salonized_pay.dashboard.terminal.flash_renamed'));
    emit('close');
  } finally {
    loading.value = false;
  }
};
</script>
